export const KeyKeyCodeMap = {
    Tab: 9,
    Enter: 13,
    Escape: 27,
    Space: 32,
    ArrowLeft: 37,
    ArrowUp: 38,
    ArrowRight: 39,
    ArrowDown: 40,
};

export const KeyTypeMap = {
    Down: 'keydown',
    Up: 'keyup',
};

export enum ResultAction {
    IGNORE,
    NO_PROPAGATE,
    NO_DEFAULT,
    BOTH,
}

// export function find(els: Array<HTMLElement>, roleSelectors: Array<string>): HTMLElement {
//     for (let i = 0; i < els.length; i++) {
//         const el = els[i];
//         const attr = el.getAttribute('role');
//         if (roleSelectors.indexOf(attr) !== -1) return el;
//     }
//     return null;
// }

// export function findParent(el: HTMLElement, roleSelectors: Array<string>): HTMLElement {
//     let parent = el.parentElement;
//     while (parent != null) {
//         const el = find([parent], roleSelectors);
//         if (el) return el;
//         parent = parent.parentElement;
//     }
//     return null;
// }

export function findParent(el: HTMLElement, selector: string): HTMLElement {
    let parent = el.parentElement;
    while (parent != null) {
        const el = parent.querySelector(selector);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        if (el) return <HTMLElement>el;
        parent = parent.parentElement;
    }
    return null;
}

export function focus(
    current: HTMLElement | HTMLElement[],
    next: HTMLElement,
): void {
    if (!next) return;
    if (current) {
        // eslint-disable-next-line no-return-assign
        (!Array.isArray(current) ? [current] : current).forEach(
            (value) => (value.tabIndex = -1),
        );
    }
    next.tabIndex = 0;
    next.focus();
}

export interface KeyboardNavigator {
    handleEvent: ($event: KeyboardEvent) => void;
}
